<div class="modal-header">
    <h5 class="modal-title" >{{ title | translate }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
  </div>

  <!-- Modal Body -->
  <div class="modal-body" *ngIf="fileType !='.pdf'">
    <div class="row text-center" ngbAutofocus *ngIf="fileType !='.pdf' && fileType !='.xlsx' && fileType !='.csv'">
      <img [src]="imageUrl" />
    </div>

    <div class="row justify-content-center">
      <div class="col-6 text-center " ngbAutofocus *ngIf="fileType == '.xlsx' || fileType =='.csv'">
        <a [href]="imageUrl" class="btn btn-outline-primary btn-lg" target="_blank">
          <i class="i-File-Excel"></i> Download
        </a>
      </div>
    </div>
    <!-- <app-loader [isLoading]="loading"></app-loader> -->
  </div>


  <!-- Modal Body -->
    <app-loader [isLoading]="loading"></app-loader>
    <div class="modal-body" *ngIf="fileType =='.pdf'" style="overflow-y: hidden;">
      <div class="row text-center" ngbAutofocus>
        <iframe [src]="safeSrcLink" width="100%" height="550px" style="border: none;">
        </iframe>
      </div>
    </div>
  <!-- Modal Footer -->
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" (click)="close()">
      {{ "close"| translate }}
    </button>
    <!-- <button type="button" class="btn btn-success" (click)="save()" [disabled]="divisionForm?.invalid || isLoading">
      {{ 'save' | translate}}
    </button> -->
  </div>